<template>
	<div style="height:80%;display: flex; justify-content: center; align-items: center">
		<div style="width: 100%">
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">订单号</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.orderSn }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">停车场ID</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.parkinglotId }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">商户名</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.businessName }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">应收金额</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.amountDeposited }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">实收金额</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.amountReceived }} </span>
				</div>
			</div>
			<button class="weui-btn weui-btn_default" @click="toPay">支付</button>
		</div>

	</div>
</template>

<script>
import { pay } from "../../api/coupon/pay";
import { redirectToWeChatAuth } from "@/utils/redirect"
import { getOpenId, getBuyId } from "../../api/coupon/auth";

export default {
	name: "scanPayMoney",
	data() {
		return {
			orderSn: undefined,
			parkinglotId: undefined,
			businessName: undefined,
			amountReceived: undefined,
			amountDeposited: undefined,
			openId: null,
			userBuyId: null,
			isSzBank: false,

		}
	},
	mounted() {

		let openIdForOrder = localStorage.getItem("userOpenId");
		let userBuyId = localStorage.getItem("userBuyId");
		if (this.$route.query.code || this.$route.query.auth_code) {
			if (this.checkBrowser.id == 13) {
				getOpenId(this.$route.query.code).then((res) => {
					if (res.code == 200) {
						//&& res.msg != 'null'
						localStorage.setItem("userOpenId", res.msg);
						this.openId = res.msg;
					} else {
						alert("未获得授权");
					}
				});
			} else {
				getBuyId(this.$route.query.auth_code).then((res) => {
					localStorage.setItem("userBuyId", res.msg);
					this.userBuyId = res.msg
				});
			}
		} else {
			console.log("1111111111111111");
			if (this.checkBrowser.id == 13) {
				//如果是微信环境就进行微信授权
				if (!openIdForOrder) {
					this.isSzBank = true;
					redirectToWeChatAuth("/weChat/salePayMoney")
				} else {
					this.isSzBank = true
					this.openId = openIdForOrder;

				}
			} else {
				if (!userBuyId) {
					redirectToWeChatAuth("/weChat/salePayMoney")
				} else {
					this.isSzBank = false
					this.userBuyId = userBuyId;
				}
			}
		}

	},
	created() {
		if (this.$route.query.parkinglotId) {
			this.parkinglotId = this.$route.query.parkinglotId;
		}
		if (this.$route.query.orderSn) {
			this.orderSn = this.$route.query.orderSn;
		}
		if (this.$route.query.amountReceived) {
			this.amountReceived = this.$route.query.amountReceived;
		}
		if (this.$route.query.amountDeposited) {
			this.amountDeposited = this.$route.query.amountDeposited;
		}
		if (this.$route.query.businessName) {
			this.businessName = this.$route.query.businessName;
		}
		// amountReceived//应收
		// amountDeposited//实收
		// businessName//商户名字
	},
	methods: {
		toPay() {
			let payForm = {
				orderSn: this.orderSn,
				totalAmount: parseFloat(this.amountReceived).toFixed(2),
				goodsType: 7,
				parkinglotId: this.parkinglotId,
				payType: this.isSzBank?13:12,
				openId: this.isSzBank?(this.openId||localStorage.getItem('userOpenId')):(this.userBuyId||localStorage.getItem('userBuyId'))
			};
			pay(payForm).then(res => {
				if (res.code == 200) {
					this.$pay(res)
				}
			})
		},
	}
}
</script>

<style scoped></style>
